import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

// Components
import Typography from '@material-ui/core/Typography';
import ImageField from 'pages/General/tabs/Theming/components/ImageField';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  logoUrl?: string | null;
}

function LogoUploader({ setFieldValue, logoUrl }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.logoUploader}>
      <Typography variant="h6">Logo</Typography>
      <Typography variant="subtitle2" component="div">
        Upload a company logo to personalize features such as your Org Chart. This logo may also be
        used in other configurations such as theming.
      </Typography>
      <Typography variant="subtitle2">
        We recommend that you use a png image with a transparent background, preferably without any
        padding around the logomark.
      </Typography>
      <ImageField
        classes={{ fileDrop: classes.fileDrop, action: classes.action }}
        onChangeImageUrl={value => setFieldValue('client.settings.info.logoUrl', value)}
        onRemove={() => setFieldValue('client.settings.info.logoUrl', undefined)}
        imageSrc={logoUrl}
        maxSize={2 * 1024 ** 2}
        example={logoUrl && <img src={logoUrl} alt="logo" className={classes.logo} />}
      />
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  logoUploader: {
    marginTop: theme.spacing(3),
  },
  logo: {
    maxWidth: 1100,
  },
  fileDrop: {
    paddingLeft: 0,
  },
  action: {
    paddingLeft: 0,
  },
}));

export default LogoUploader;
